import api from "./api";

class CourierService {
  async createDelivery(data: any) {
    const res = await api.post("/deliveries", data);
    return res.data.delivery || res.data.data;
  }
  async createDriverAssignment(data: any) {
    const res = await api.post("/driver-assignments", data);
    return res.data.assignment || res.data.data;
  }
  async createServiceSubzone(data: any) {
    // data should include: name, description, zone_id
    const res = await api.post("/subzones", data);
    return res.data; // Directly return the object
  }
  async createServiceZone(data: any) {
    const res = await api.post("/service-zones", data);
    return res.data.zone || res.data.data;
  }
  async deleteDelivery(id: number | string) {
    const res = await api.delete(`/deliveries/${id}`);
    return res.data;
  }
  async deleteDriverAssignment(id: number | string) {
    const res = await api.delete(`/driver-assignments/${id}`);
    return res.data;
  }
  async deleteServiceSubzone(
    zoneId: number | string,
    subzoneId: number | string,
  ) {
    const res = await api.delete(`/subzones/${subzoneId}`);
    return res.data;
  }
  async deleteServiceZone(id: number | string) {
    const res = await api.delete(`/service-zones/${id}`);
    return res.data;
  }
  // Deliveries
  async getDeliveries(createdBy?: string) {
    if (!createdBy) {
      throw new Error(
        "createdBy (logged-in user id) is required to fetch deliveries.",
      );
    }
    try {
      const params = { params: { created_by: createdBy } };
      const res = await api.get("/deliveries", params);
      const data = res.data.data || res.data.deliveries || res.data || [];
      if (Array.isArray(data) && data.length > 0) return data;

      // Fallback: some backends expose a "my-deliveries" endpoint
      try {
        const res2 = await api.get("/deliveries/my-deliveries");
        return res2.data.data || res2.data.deliveries || res2.data || [];
      } catch (err) {
        return data;
      }
    } catch (err) {
      // If the primary call fails, attempt the fallback before throwing
      try {
        const res2 = await api.get("/deliveries/my-deliveries");
        return res2.data.data || res2.data.deliveries || res2.data || [];
      } catch (err2) {
        throw err; // rethrow original error
      }
    }
  }
  async getDelivery(id: number | string) {
    const res = await api.get(`/deliveries/${id}`);
    return res.data.delivery || res.data.data;
  }
  async getDriverAssignment(id: number | string) {
    const res = await api.get(`/driver-assignments/${id}`);
    return res.data.assignment || res.data.data;
  }
  // Driver Assignments
  async getDriverAssignments(createdBy?: string) {
    const params = createdBy ? { params: { created_by: createdBy } } : {};
    const res = await api.get("/driver-assignments", params);
    return res.data.data || res.data.assignments || res.data || [];
  }
  async getDriversList() {
    const res = await api.get("/drivers/list");
    return res.data.data || res.data.drivers || res.data || [];
  }

  async getServiceSubzone(zoneId: number | string, subzoneId: number | string) {
    const res = await api.get(`/subzones/${subzoneId}`);
    return res.data.subzone || res.data.data;
  }
  async getServiceSubzones(zoneId: number | string) {
    const res = await api.get(`/subzones`);
    return res.data.data || res.data.subzones || res.data || [];
  }
  async getServiceZone(id: number | string) {
    const res = await api.get(`/service-zones/${id}`);
    return res.data.zone || res.data.data;
  }
  // Service Zones
  async getServiceZones(createdBy?: string) {
    const params = createdBy ? { params: { created_by: createdBy } } : {};
    const res = await api.get("/service-zones", params);
    return res.data.data || res.data.zones || res.data || [];
  }
  async getVehiclesList() {
    const res = await api.get("/vehicles/list");
    return res.data.data || res.data.vehicles || res.data || [];
  }

  async toggleDriverAvailability(id: number | string) {
    const res = await api.patch(
      `/driver-assignments/${id}/toggle-availability`,
    );
    return res.data;
  }
  async updateDelivery(id: number | string, data: any) {
    const res = await api.put(`/deliveries/${id}`, data);
    return res.data.delivery || res.data.data;
  }
  async updateDeliveryStatus(id: number | string, status: string) {
    const res = await api.patch(`/deliveries/${id}/status`, { status });
    return res.data.delivery || res.data.data;
  }
  async updateDriverAssignment(id: number | string, data: any) {
    const res = await api.put(`/driver-assignments/${id}`, data);
    return res.data.assignment || res.data.data;
  }
  async updateDriverStatus(id: number | string, status: string) {
    const res = await api.patch(`/drivers/${id}/status`, { status });
    return res.data.driver || res.data.data;
  }
  async updateServiceSubzone(
    zoneId: number | string,
    subzoneId: number | string,
    data: any,
  ) {
    const res = await api.put(`/subzones/${subzoneId}`, data);
    return res.data.subzone || res.data.data;
  }
  async updateServiceZone(id: number | string, data: any) {
    const res = await api.put(`/service-zones/${id}`, data);
    return res.data.zone || res.data.data;
  }
  async updateVehicleStatus(id: number | string, status: string) {
    const res = await api.patch(`/vehicles/${id}/status`, { status });
    return res.data.vehicle || res.data.data;
  }

  // Subzone CRUD (matching your backend routes)
  // async createServiceSubzone(data: any) {
  //   // data should include: name, description, zone_id
  //   const res = await api.post("/subzones", data);
  //   return res.data.subzone || res.data.data;
  // }
  // async getServiceSubzone(subzoneId: number | string) {
  //   const res = await api.get(`/subzones/${subzoneId}`);
  //   return res.data.subzone || res.data.data;
  // }
  // async getServiceSubzones() {
  //   const res = await api.get("/subzones");
  //   return res.data.data || res.data.subzones || res.data || [];
  // }
  // async updateServiceSubzone(subzoneId: number | string, data: any) {
  //   const res = await api.put(`/subzones/${subzoneId}`, data);
  //   return res.data.subzone || res.data.data;
  // }
  // async deleteServiceSubzone(subzoneId: number | string) {
  //   const res = await api.delete(`/subzones/${subzoneId}`);
  //   return res.data;
  // }
}

export default new CourierService();
